import { databases, DATABASE_ID, USERS_COLLECTION_ID } from '../config/appwrite';
import DBConstants from '../constants/db.constants';
import SecurityConstants from '../constants/security.constants';

declare global {
  interface Window {
    Firebug?: {
      chrome?: {
        isInitialized: boolean;
      };
    };
  }
}

export const preventDevTools = () => {
  // Improved device detection including Smart TVs
  const isSmartTV =
    /\b(smart-tv|smarttv|tv|webos|tizen|vidaa|hbbtv|cehtml|netcast|sailfish|webos)\b/i.test(
      navigator.userAgent.toLowerCase()
    );
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOSSafari = isIOS && isSafari;

  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  // Only apply DevTools prevention on desktop browsers
  const isDesktop = !isMobile && !isSmartTV;

  // Prevent right-click only on desktop
  if (isDesktop) {
    document.addEventListener('contextmenu', e => e.preventDefault());
  }

  // Prevent F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  // These shortcuts are only relevant on desktop
  if (isDesktop) {
    document.addEventListener('keydown', e => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key === 'I' || e.key === 'i' || e.key === 'J' || e.key === 'j')) ||
        (e.ctrlKey && (e.key === 'U' || e.key === 'u'))
      ) {
        e.preventDefault();
      }
    });
  }

  // Detect if DevTools is opened - only for desktop browsers
  if (SecurityConstants.DEVTOOLS_DETECTION_ENABLED && isDesktop && !isIOSSafari) {
    const threshold = 320;
    // Require this many consecutive positive checks (~3s) before acting
    const REQUIRED_CONSECUTIVE = 6;
    let consecutiveCount = 0;
    let paused = false;
    let devtoolsOpen = false;

    // Pause detection briefly after resize/orientation to avoid false positives
    const pauseDetection = () => {
      paused = true;
      consecutiveCount = 0;
      setTimeout(() => { paused = false; }, 1500);
    };

    window.addEventListener('resize', pauseDetection);
    window.addEventListener('orientationchange', pauseDetection);

    const blockUser = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.role !== 'admin' && user.role !== 'superadmin' && user.id) {
        databases
          .updateDocument(DATABASE_ID, USERS_COLLECTION_ID, user.id, { is_blocked: true })
          .then(() => { window.location.href = '/blocked'; })
          .catch(err => { console.error('Error blocking user:', err); });
      }
    };

    setInterval(() => {
      if (paused) return;

      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;
      const firebug = window.Firebug && window.Firebug.chrome && window.Firebug.chrome.isInitialized;

      const isOpen =
        firebug ||
        (!(widthThreshold && heightThreshold) && (widthThreshold || heightThreshold));

      if (isOpen) {
        consecutiveCount++;
        if (!devtoolsOpen && consecutiveCount >= REQUIRED_CONSECUTIVE) {
          devtoolsOpen = true;
          blockUser();
        }
      } else {
        consecutiveCount = 0;
        devtoolsOpen = false;
      }
    }, 500);
  }

  // Optional: Add specific handling for Smart TVs if needed
  if (isSmartTV) {
    // Smart TV specific security measures could go here
    // Usually not needed as Smart TVs don't have developer tools
    console.debug('Smart TV detected, skipping DevTools detection');
  }

  // For mobile, we can add specific mobile-only security measures here if needed
  if (isMobile) {
    // Optional: Add any mobile-specific security measures
    // For example, detecting iOS Safari Web Inspector or Android Debug Bridge
    // This would be platform-specific implementations
  }
};
